// extracted by mini-css-extract-plugin
export default {"container":"styles_container__nDFDC","text_center":"styles_text_center__3bv2f","phone":"styles_phone__BNXAO"};